import { TEXTS } from 'application/pages/BillingPage/renderer/texts';

import { WRONG_PAYMENT_KIND_ERROR } from '@entities/billing';
import { toast } from '@shared/ui';

import { IS_NEED_SHOW_LICENSES_MODAL } from './licensesModalStorageKeys';

export const handleBindCardError = async (error: Error, refetchBillingInfo: () => Promise<unknown>) => {
  localStorage.removeItem(IS_NEED_SHOW_LICENSES_MODAL);

  const isWrongPaymentError = WRONG_PAYMENT_KIND_ERROR.test(error.message);

  if (isWrongPaymentError) {
    await refetchBillingInfo();
  }

  toast.error(isWrongPaymentError ? error.message : TEXTS.BILLING_BIND_CARD_NOTIFICATION_ERROR_MESSAGE);
};
